import React, { Component } from 'react';
import { Button } from 'antd';
import { connect } from 'react-redux';

import {
  getInternetAccess,
  getAutoSaveDraft,
} from 'APP_ROOT/selectors/application';

import EditorSaveButton from '../../containers/administrator/components/EditorSaveButton';
import { translate } from 'APP_ROOT/i18next';

class TabNavigation extends Component {
  shouldComponentUpdate(props) {
    const { next, prev, ...rest } = props;
    const { next: oldNext, prev: oldPrev, ...oldRest } = this.props;
    return JSON.stringify(rest) !== JSON.stringify(oldRest);
  }

  render() {
    const {
      current = 0,
      showSubmitButton = false,
      submitButtonLabel = 'Submit',
      showNavigation = true,
      submitDisable = true,
      isViewer = false,
      onNext = () => {},
      onPrev = () => {},
      totalSteps = 1,
      loading = false,
      canSubmit = true,
      isEditMode = false,
      isEditor,
      internetAccess,
      hasPrev,
      hasNext,
    } = this.props;

    // Fall back to the index-based defaults when the caller does not supply
    // explicit visibility-aware flags, so non-conditional-tab callers keep
    // their current behavior.
    const showPrev = hasPrev === undefined ? current > 0 : hasPrev;
    const showNext =
      hasNext === undefined ? current < totalSteps - 1 : hasNext;

    return (
      <div className="btm-form-steps-navigation">
        {showPrev && showNavigation && (
          <Button type="primary" ghost onClick={onPrev}>
            {translate('containers.reports.previous')}
          </Button>
        )}

        {showNext && showNavigation && (
          <Button
            type="primary"
            ghost
            style={{ marginLeft: 8 }}
            onClick={onNext}
          >
            {translate('containers.reports.next')}
          </Button>
        )}

        {showSubmitButton && !isEditor && (canSubmit || isViewer) && (
          <Button
            type="primary"
            style={{ marginLeft: 8 }}
            htmlType="submit"
            disabled={loading || submitDisable || !internetAccess}
            loading={loading}
          >
            {isViewer && !isEditMode ? 'View Report' : submitButtonLabel}
          </Button>
        )}

        {isEditor && <EditorSaveButton loading={loading} disabled={true} />}
      </div>
    );
  }
}

const mapState = (state, props) => {
  return {
    internetAccess: getInternetAccess(state),
    autoSaveDraft: getAutoSaveDraft(state),
  };
};

export default connect(mapState)(TabNavigation);
